import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import "./courseQuiz.scss";
import { getQuestionsByCourse } from '../../../../services/routeServices';
import authContext from 'shared/src/contexts/authContext';
import { getToken } from 'shared/src/services/user-info.service';
import checkFeedback from 'assets/credits/check_feedback.svg';
import { Realimentacion } from './Realimentacion';

interface CourseQuizProps {
  resultQuiz: any[];
  buttonEvent: boolean;
  isFinished: boolean;
  isResetQuiz: boolean;
  evaluationBlocked: boolean;
  setResponseModalAction: React.Dispatch<React.SetStateAction<string | undefined>>;
  setResponseModalValue: React.Dispatch<React.SetStateAction<boolean | undefined>>;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  setResultQuiz: React.Dispatch<React.SetStateAction<any>>;
  setButtonEvent: React.Dispatch<React.SetStateAction<boolean>>;
  setIsFinished: React.Dispatch<React.SetStateAction<boolean>>;
  setIsResetQuiz: React.Dispatch<React.SetStateAction<boolean>>;
  setShowEvaluation: React.Dispatch<React.SetStateAction<boolean>>;
}

interface Option {
  id: number;
  name: string;
  correctOption: boolean;
}

interface Question {
  id: number;
  name: string;
  type: {
    id: number;
    name: string;
  };
  horizontal: boolean;
  required: boolean;
  options: Option[];
  purpose: number;
}

const CourseQuiz: React.FC<CourseQuizProps> = (
  { resultQuiz, buttonEvent, isFinished, evaluationBlocked, setShowModal, setShowEvaluation, setResultQuiz, setButtonEvent, setIsFinished }
) => {

  const [stateForm, setStateForm] = useState<number>(0);
  const [currentQuestion, setCurrentQuestion] = useState<number>(0)


  const [optionSelected, setOptionSelected] = useState<Option>()
  const [classValueCorrect, setClassValueCorrect] = useState<string>("")
  const [elementIncorrect, setElementIncorrect] = useState<HTMLButtonElement>()
  const [questions, setQuestions] = useState<Question[]>([]);
  const [exitEvaluation, setExitEvaluation] = useState()
  const [localEventExit, setLocalEventExit] = useState(false);
  const auth = useContext(authContext);

  const containerOptionsRef = useRef<HTMLDivElement>(null);

  const TEXT_BUTTON = ["Iniciar", "Enviar respuesta", "Siguiente"]


  const getQuestiosData = async () => {
    try {
      const questiosData = await getQuestionsByCourse();
      setQuestions(questiosData.data.data[0].questions)
    } catch (error) {
      console.error("Error al obtener las preguntas del curso.");
    }
  }

  const validateQuestion = () => {

    if (stateForm == 0) {
      setStateForm(1)
      localStorage.setItem("evaluationInProgress", "true");
    }
    else if (stateForm == 1) {

      setResultQuiz([...resultQuiz, {
        idQuestion: questions[currentQuestion].id,
        optionSelected
      }])



      if (optionSelected?.correctOption == false) {
        elementIncorrect?.classList.add("incorrect");
        elementIncorrect?.classList.remove("selected");
        setClassValueCorrect("correct--show")
      } else {
        setClassValueCorrect("correct")
      }

      setStateForm(2)

    } else if (stateForm == 2) {
      if (currentQuestion < questions.length - 1) {
        setCurrentQuestion(currentQuestion + 1)
        setStateForm(1)
      } else {
        setIsFinished(true);
        localStorage.setItem("evaluationInProgress", "false");
      }
      setOptionSelected(undefined);
      setClassValueCorrect("");
    }

    setButtonEvent(false)
  }

  const blockOptions = (event: React.MouseEvent<HTMLButtonElement>) => {
    const { currentTarget } = event;

    const buttons = containerOptionsRef.current?.querySelectorAll("button");


    currentTarget.classList.toggle("selected", !currentTarget.classList.contains("selected"));

    const relevantClasses = ["selected", "correct", "incorrect"];
    const shouldDisable = relevantClasses.some(className => currentTarget.classList.contains(className));

    if (buttons) {
      buttons.forEach((buttonitem: HTMLButtonElement) => {
        buttonitem.disabled = shouldDisable;
      });
    }

    currentTarget.disabled = false;
  };

  const changeWithOptiosn = () => {

    if (stateForm === 1) {
      const botones: HTMLCollectionOf<HTMLButtonElement> | undefined = containerOptionsRef.current?.getElementsByTagName("button");

      if (botones && botones.length > 0) {

        const containerOptionsWidth: any = containerOptionsRef.current?.clientWidth;
        const containerOptionsWidthyVW: any = (containerOptionsWidth / document.documentElement.clientWidth) * 100;

        let maxWidth = 0;

        Array.from(botones).forEach((element: HTMLButtonElement) => {
          maxWidth = Math.max(maxWidth, element.clientWidth);
        });

        const widthInVw = ((maxWidth + 40) / (containerOptionsWidth + 40)) * containerOptionsWidthyVW;

        Array.from(botones).forEach((element: HTMLButtonElement) => {
          element.style.width = `${widthInVw}vw`;
        });
      }
    }
  }

  const goBack = () => {
    const evaluationInProgress = localStorage.getItem("evaluationInProgress");
    if (evaluationInProgress && evaluationInProgress == "true") {
      setShowModal(true)
      return;
    }
    setShowEvaluation(false);
  }

  useEffect(() => {
    if (buttonEvent) {
      validateQuestion();
    }
  }, [buttonEvent]);

  useEffect(() => {

    if (isFinished == false) {
      setCurrentQuestion(0);
      setStateForm(0)
      setOptionSelected(undefined);
      setResultQuiz([])
    }
  }, [isFinished]);

  useEffect(() => {
    changeWithOptiosn()
  }, [currentQuestion, stateForm == 1]);


  useEffect(() => {
    getQuestiosData();
  }, []);

  return (
    questions.length > 0 ?
      <div className='evaluation-container'>
        <div className='evaluation-container__goback'>
          <button className="back-button" onClick={() => {
            goBack();
          }}>
            <span className="material-icons md-18">arrow_back</span>
            <p>Volver</p>
          </button>
        </div>
        <h2>¡Es hora de poner a prueba lo que aprendiste!</h2>
        <div className="evaluation-container__question">
          {
            stateForm == 0 ?
              <div className="evaluation-container__question__introduction">
                <h3>Ten en cuenta:</h3>
                <ol>
                  <li>Te haremos 6 preguntas de lo visto en los módulos.</li>
                  <li>Cada pregunta correcta te dará 3 puntos.</li>
                  <li>Se descontará un punto por cada error.</li>
                  <li>Puedes volver a realizar la prueba si obtienes una puntuación inferior al 70%.</li>
                </ol>
              </div>
              :
              <div className="evaluation-container__question__form">
                <div className="evaluation-container__question__form__header">
                  <span>Pregunta {currentQuestion + 1} de {questions.length}</span>
                </div>
                <div className="evaluation-container__question__form__body">
                  <p>{questions[currentQuestion].name}</p>
                  <div ref={containerOptionsRef} className="evaluation-container__question__form__body__options">
                    {
                      questions[currentQuestion].options.map((option: Option) => (
                        <>
                          <button
                            className={option.correctOption ? classValueCorrect : ""}
                            id={"option" + option.id.toString()}
                            key={option.id}
                            onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                              blockOptions(event);
                              !optionSelected ? setOptionSelected(option) : setOptionSelected(undefined);
                              setElementIncorrect(event.currentTarget)
                            }}>
                            {option.name}
                          </button>
                          <br />
                        </>
                      ))
                    }
                  </div>
                </div>
              </div>
          }
        </div>
        {
          stateForm == 2 &&
            <>
              {resultQuiz[currentQuestion].optionSelected.correctOption === true &&
              <div className={`evaluation-container__feedback ${evaluationBlocked && 'button--disabled'}`}>
                <img src={checkFeedback} />
                  <Realimentacion currentQuestion={currentQuestion} />
              </div>
              }
              </>
            }
        {evaluationBlocked &&
          <div className='evaluation-container__controls__error'>
            <p>Para desbloquear la evaluación debes mirar <br/>todos los videos y marcarlos con 'Ya lo hice'</p>
          </div>
        }
        <div className='evaluation-container__controls'>
          <button
            disabled={evaluationBlocked ? true : stateForm == 1 && optionSelected == undefined ? true : false}

            onClick={() => {
              setButtonEvent(true);
            }}>{TEXT_BUTTON[stateForm]}</button>
        </div>
      </div>
      : <></>
  )
}

export default CourseQuiz
